import secondaryComponents from "../../../../../components/secondaryComponents";
import primaryComponents from "../../../../../components/primaryComponents";
import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import { useAllConnections } from "./useAllConnections";
import { ConnectStoreIcon } from "../../../../../assets/svgIcons";
import { useNavigate } from "react-router-dom";
import { pathConstants } from "../../../../../routes/pathContants";
import { ChowdeckConnectionTable } from "../../../../../components/secondaryComponents/Chowdeck";

const Connections = () => {
  const navigate = useNavigate();
  const {
    isLoading,
    search,
    storesMappingList,
    metaDetails,
    gotoPage,
    filterBySearch,
  } = useAllConnections();

  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | App - Chowdeck Connections"
      description="View all Chowdeck connections"
    >
      <secondaryComponents.RequestLoaderTrigger>
        <div className={`${globalStyles.pageColumnGaps}`}>
          <div>
            <h4 className="mb-0">Manage Chowdeck App</h4>
            <p>Connect & manage Chowdeck stores and API with Lumi Business</p>
          </div>

          <div className={globalStyles.pageHeaders}>
            <p>
              {storesMappingList?.length} Connection
              {storesMappingList?.length > 1 ? "s" : ""}
            </p>
            <primaryComponents.Button
              classNames={"btn btn--primary"}
              onClick={() =>
                navigate(`${pathConstants.APPS_CHOWDECK_API_MANAGEMENT}`)
              }
            >
              <ConnectStoreIcon className="mr-1" color="white" />
              Connect Store
            </primaryComponents.Button>
          </div>

          <div className={`${globalStyles.tableWrapper}`}>
            <div className={`${globalStyles.tableHeader}`}>
              <primaryComponents.SearchField
                value={search.get("query") || ""}
                placeholder={"Search for a connection"}
                triggerOnInput={true}
                showsearchBtn={true}
                trigger={(value) => filterBySearch(value)}
                classNames={`${globalStyles.searchField}`}
              />
            </div>

            <secondaryComponents.LoaderHelper
              isLoading={isLoading}
              classNames={"mt-5"}
            >
              <ChowdeckConnectionTable
                chowdeckConnectionsList={storesMappingList}
                metaDetails={metaDetails}
                gotoPage={gotoPage}
              />
            </secondaryComponents.LoaderHelper>
          </div>
        </div>
      </secondaryComponents.RequestLoaderTrigger>
    </secondaryComponents.MetaSetter>
  );
};

export default Connections;
